"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = void 0;
var Platform;
(function (Platform) {
    Platform["landing"] = "landing";
    Platform["app"] = "app";
})(Platform = exports.Platform || (exports.Platform = {}));
class AuthModule {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    async sendToken(email_or_cpf, platform, agreement_id) {
        const { data } = await this.axiosInstance.post("/api/v2/user/auth/", {
            cpf: email_or_cpf,
            platform,
            agreement: agreement_id,
        });
        return data;
    }
    async getToken(email_or_cpf, password) {
        return await this.axiosInstance
            .post("/api/v1/users/tokens/", { username: email_or_cpf, password })
            .then(({ data }) => data);
    }
    setToken(token) {
        this.axiosInstance.defaults.headers.common["Authorization"] = `TOKEN ${token}`;
    }
    clearToken() {
        delete this.axiosInstance.defaults.headers.common["Authorization"];
    }
    login(token) {
        console.warn("The method auth.login is deprecated. Use setToken.");
        this.axiosInstance.defaults.headers.common["Authorization"] = `TOKEN ${token}`;
    }
    logout() {
        console.warn("The method auth.logout is deprecated. Use clearToken.");
        delete this.axiosInstance.defaults.headers.common["Authorization"];
    }
}
exports.default = AuthModule;
//# sourceMappingURL=auth.js.map